export const prevArrow = `
    <button class="slider__arrow slider__prev slick-prev button button--ghost" aria-label="Previous slide">
        ${Nu.arrows.left}
    </button>`;
export const nextArrow = `
    <button class="slider__arrow slider__next slick-next button button--ghost" aria-label="Next slide">
        ${Nu.arrows.right}
    </button>`;

export const options = {
    slidesToShow: 1,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    mobileFirst: true,
    speed: 600,
    respondTo: 'slider',
    nextArrow: nextArrow,
    prevArrow: prevArrow
};
;
